import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/webs/Index'
import Jsbs from '@/components/webs/Jsbs'
import Jszg from '@/components/webs/Jszg'
import Jsms from '@/components/webs/Jsms'
import Jzbs from '@/components/webs/Jzbs'
import Calendar from '@/components/single/calendar'
import Calendar2 from '@/components/single/calendar2'
import NewsList from '@/components/single/NewsList'
import ArticleList from '@/components/article/ArticleList'
import Listforold from '@/components/article/Listforold'
import ClassDetail from '@/components/class/ClassDetail'
import CouponClassList from '@/components/class/CouponClassList'
import ClassDetailTeacher from '@/components/class/ClassDetailTeacher'
import ClassSingle from '@/components/share/popup/class/ClassSingle'
import ClassAll from '@/components/share/popup/class/ClassAll'
import QQqun from '@/components/share/popup/class/QQqun'
import PaySuccess from '@/components/share/popup/order/PaySuccess'
import Unlock from '@/components/share/popup/class/Unlock'
import iShare from '@/components/share/popup/class/iShare'
import LivePlay from '@/components/play/LivePlay'
import LivePlayer from '@/components/play/LivePlayer'
import VideoPlay from '@/components/play/VideoPlay'
import FreePlay from '@/components/play/FreePlay'
import OrderDetail from '@/components/order/OrderDetail'
import OrderConfirm from '@/components/order/OrderConfirm'
import OrderRepay from '@/components/order/OrderRepay'
import OrderPaying from '@/components/order/OrderPaying'
import OrderRepaying from '@/components/order/OrderRepaying'
import OrderCoupon from '@/components/order/OrderCoupon'
import MyCoupon from '@/components/personal/MyCoupon'
import AddressList from '@/components/personal/AddressList'
import AddressEdit from '@/components/personal/AddressEdit'
import ExamBank from '@/components/exam/ExamBank'
import ExamChapter from '@/components/exam/ExamChapter'
import ExamSection from '@/components/exam/ExamSection'
import ExamTest from '@/components/exam/ExamTest'
import WrongTest from '@/components/exam/WrongTest'
import ExamAnswer from '@/components/exam/ExamAnswer'
import ExamCard from '@/components/exam/ExamCard'
import ExamResult from '@/components/exam/ExamResult'
import ExamSubmit from '@/components/exam/ExamSubmit'
import ExamScore from '@/components/exam/ExamScore'
import WrongBank from '@/components/exam/WrongBank'
import ExamShare from '@/components/exam/ExamShare'
import PersonInfo from '@/components/personal/PersonInfo'
import PersonCenter from '@/components/personal/PersonCenter'
import PersonSign from '@/components/personal/PersonSign'
import PersonVip from '@/components/personal/PersonVip'
import PersonPoint from '@/components/personal/PersonPoint'
import MyMaterial from '@/components/personal/MyMaterial'
import PersonSet from '@/components/personal/PersonSet'
import Introduction from '@/components/single/Introduction'
import RuleVip from '@/components/single/RuleVip'
import RuleSign from '@/components/single/RuleSign'
import AppDown from '@/components/single/AppDown'
import AppDownLoad from '@/components/single/AppDownLoad'
import BuyVip from '@/components/personal/BuyVip'
import PersonNote from '@/components/personal/PersonNote'
import MyClass from '@/components/personal/MyClass'
import MyOrder from '@/components/personal/MyOrder'
import HeadTeacher from '@/components/personal/HeadTeacher'
import PwdForget from '@/components/login/PwdForget'
import MobileLogin from '@/components/login/MobileLogin'
import PwdLogin from '@/components/login/PwdLogin'
import StudyAim from '@/components/login/StudyAim'
import MobileBind from '@/components/login/MobileBind'
import MyCollection from '@/components/personal/MyCollection'
import ArticleDetail from '@/components/article/ArticleDetail'
import Detailforold from '@/components/article/Detailforold'
import MyCalendar from '@/components/personal/MyCalendar'
import testGet from '@/components/test/testGet'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/hello', // 测试页
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        title: '2022年中小幼教师资格证报名_考试时间|入口及报考条件_考试教材'
      }
    },
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/jszg', // 教资-笔试 新 20191017
      name: 'Jszg',
      component: Jszg
    },
    {
      path: '/jsbs', // 教资-笔试
      name: 'Jsbs',
      component: Jsbs
    },
    {
      path: '/jsms', // 教资-面试
      name: 'Jsms',
      component: Jsms
    },
    {
      path: '/jzbs', // 教招
      name: 'Jzbs',
      component: Jzbs
    },
    {
      path: '/newslist', // 热点资讯（旧）
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/articlelist', // 热点资讯（新）
      name: 'ArticleList',
      component: ArticleList
    },
    {
      path: '/wp_index/article', // 热点资讯 for 旧网址路径保留使用 20191107
      name: 'Listforold',
      component: Listforold
    },
    {
      path: '/calendar', // 考试日历 笔试
      name: 'Calendar',
      component: Calendar
    },
    {
      path: '/calendar2', // 考试日历 面试
      name: 'Calendar2',
      component: Calendar2
    },
    {
      path: '/classdetail', // 详情页
      name: 'ClassDetail',
      component: ClassDetail
    },
    {
      path: '/classdetailteacher', // 详情页-课程列表、详情页-授课老师
      name: 'ClassDetailTeacher',
      component: ClassDetailTeacher
    },
    {
      path: '/couponclasslist', // 可用优惠券课程列表
      name: 'CouponClassList',
      component: CouponClassList
    },
    {
      path: '/classsingle', // 购买单科、购买双科
      name: 'ClassSingle',
      component: ClassSingle
    },
    {
      path: '/classall', // 课程弹窗
      name: 'ClassAll',
      component: ClassAll
    },
    {
      path: '/qqqun', // 加群弹窗
      name: 'QQqun',
      component: QQqun
    },
    {
      path: '/paysuccess', // 支付成功
      name: 'PaySuccess',
      component: PaySuccess
    },
    {
      path: '/unlock', // 解锁免费试听
      name: 'Unlock',
      component: Unlock
    },
    {
      path: '/ishare', // 分享朋友圈
      name: 'iShare',
      component: iShare
    },
    {
      path: '/liveplay', // 播放、未播放
      name: 'LivePlay',
      component: LivePlay
    },
    {
      path: '/liveplayer', // 直播间
      name: 'LivePlayer',
      component: LivePlayer
    },
    {
      path: '/videoplay', // 录播
      name: 'VideoPlay',
      component: VideoPlay
    },
    {
      path: '/freeplay', // 免费试听
      name: 'FreePlay',
      component: FreePlay
    },
    {
      path: '/orderdetail', // 订单详情
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/orderconfirm', // 订单确认
      name: 'OrderConfirm',
      component: OrderConfirm
    },
    {
      path: '/orderrepay', // 继续支付，订单确认
      name: 'OrderRepay',
      component: OrderRepay
    },
    {
      path: '/orderpaying', // 订单确认
      name: 'OrderPaying',
      component: OrderPaying
    },
    {
      path: '/orderrepaying', // 继续支付，返回订单确认
      name: 'OrderRepaying',
      component: OrderRepaying
    },
    {
      path: '/ordercoupon', // 优惠券
      name: 'OrderCoupon',
      component: OrderCoupon
    },
    {
      path: '/mycoupon', // 我的优惠券
      name: 'MyCoupon',
      component: MyCoupon
    },
    {
      path: '/mycalendar', // 我的优惠券
      name: 'MyCalendar',
      component: MyCalendar
    },
    {
      path: '/addresslist', // 我的收货地址
      name: 'AddressList',
      component: AddressList
    },
    {
      path: '/addressedit', // 地址编辑
      name: 'AddressEdit',
      component: AddressEdit
    },
    {
      path: '/exambank', // 题库
      name: 'ExamBank',
      component: ExamBank
    },
    {
      path: '/examchapter', // 章
      name: 'ExamChapter',
      component: ExamChapter
    },
    {
      path: '/examsection', // 节
      name: 'ExamSection',
      component: ExamSection
    },
    {
      path: '/examtest', // 答题
      name: 'ExamTest',
      component: ExamTest
    },
    {
      path: '/wrongtest', // 答题
      name: 'WrongTest',
      component: WrongTest
    },
    {
      path: '/examanswer', // 答题-答案
      name: 'ExamAnswer',
      component: ExamAnswer
    },
    {
      path: '/examcard', // 答题卡
      name: 'ExamCard',
      component: ExamCard
    },
    {
      path: '/examresult', // 答题卡-正确
      name: 'ExamResult',
      component: ExamResult
    },
    {
      path: '/examsubmit', // 答题卡-交卷
      name: 'ExamSubmit',
      component: ExamSubmit
    },
    {
      path: '/wrongbank', // 错题集
      name: 'WrongBank',
      component: WrongBank
    },
    {
      path: '/examscore', // 考试成绩
      name: 'ExamScore',
      component: ExamScore
    },
    {
      path: '/examshare', // 成绩分享
      name: 'ExamShare',
      component: ExamShare
    },
    {
      path: '/personinfo', // 个人信息页面 我的备份3
      name: 'PersonInfo',
      component: PersonInfo
    },
    {
      path: '/personcenter', // 个人中心
      name: 'PersonCenter',
      component: PersonCenter
    },
    {
      path: '/personsign', // 会员备份2
      name: 'PersonSign',
      component: PersonSign
    },
    {
      path: '/personvip', // 会员备份
      name: 'PersonVip',
      component: PersonVip
    },
    {
      path: '/buyvip', // 会员备份 4
      name: 'BuyVip',
      component: BuyVip
    },
    {
      path: '/personpoint', // 会员备份6
      name: 'PersonPoint',
      component: PersonPoint
    },
    {
      path: '/mymaterial', // 资料下载
      name: 'MyMaterial',
      component: MyMaterial
    },
    {
      path: '/personset', // 设置
      name: 'PersonSet',
      component: PersonSet
    },
    {
      path: '/introduction', // 关于我们 简介
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/rulevip', // 会员规则 会员备份3
      name: 'RuleVip',
      component: RuleVip
    },
    {
      path: '/rulesign', // 积分规则 会员备份5
      name: 'RuleSign',
      component: RuleSign
    },
    {
      path: '/appdown', // app下载页面
      name: 'AppDown',
      component: AppDown
    },
    {
      path: '/appdownload', // app下载页面 二
      name: 'AppDownLoad',
      component: AppDownLoad
    },
    {
      path: '/personnote', // 通知
      name: 'PersonNote',
      component: PersonNote
    },
    {
      path: '/myclass', // 我的课程
      name: 'MyClass',
      component: MyClass
    },
    {
      path: '/myorder', // 我的订单
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/headteacher', // 我的班主任
      name: 'HeadTeacher',
      component: HeadTeacher
    },
    {
      path: '/mycollection', // 试题收藏
      name: 'MyCollection',
      component: MyCollection
    },
    {
      path: '/pwdforget', // 忘记密码
      name: 'PwdForget',
      component: PwdForget
    },
    {
      path: '/mobilelogin', // 手机快捷登录
      name: 'MobileLogin',
      component: MobileLogin
    },
    {
      path: '/pwdlogin', // 账号密码登录
      name: 'PwdLogin',
      component: PwdLogin
    },
    {
      path: '/studyaim', // 目标
      name: 'StudyAim',
      component: StudyAim
    },
    {
      path: '/mobilebind', // 手机号绑定
      name: 'MobileBind',
      component: MobileBind
    },
    {
      path: '/articledetail/:new_id', // 文章详情页
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/wp_index/detail', // 文章详情页  for 拼旧站文章同网址跳转
      name: 'Detailforold',
      component: Detailforold
    },
    {
      path: '/testget', // 测试
      name: 'testGet',
      component: testGet
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js